import React, { useEffect, useState } from "react";
import { Button, Modal } from "antd";
import { apiGetAutomationLogs, apiClearAutomationLogs } from "api/apiTws";

const AutomationLogsModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [logsContent, setLogsContent] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const clearLogs = async () => {
    try {
      await apiClearAutomationLogs();
      setLogsContent("");
    } catch (err) {
      console.error(err);
    }
  };

  const getLogs = async () => {
    setIsLoading(true);
    try {
      const logs = await apiGetAutomationLogs();
      const logLines = logs.split("\n");
      const reversedLogLines = logLines.reverse();
      const reversedLogContent = reversedLogLines.join("\n");
      setLogsContent(reversedLogContent);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let intervalId;
    if (isOpen) {
      getLogs();
      intervalId = setInterval(getLogs, 5000);
    } else {
      clearInterval(intervalId);
    }
    return () => clearInterval(intervalId);
  }, [isOpen]);

  return (
    <>
      <Button type="default" onClick={() => setIsOpen(true)}>
        View Logs
      </Button>
      <Modal
        title="Logs"
        open={isOpen}
        onCancel={() => setIsOpen(false)}
        footer={null}
        width={800}
        destroyOnClose={true}
      >
        <div>
          <div className="flex gap-2">
            <Button onClick={getLogs} loading={isLoading}>
              Refresh
            </Button>
            <Button onClick={clearLogs} loading={isLoading}>
              Clear
            </Button>
          </div>
          <div className="pt-2 overflow-auto">
            <pre>{logsContent}</pre>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AutomationLogsModal;
